import React from 'react';
import './MapSection.css';
import { useTranslation } from 'react-i18next';

const MapSection = () => {
  const { t } = useTranslation();

  return (
    <section id="location" className="map-section">
      <h2>{t('location.title')}</h2>
      <p className="map-subtext">{t('location.description')}</p>
      <div className="map-container">
        <iframe
          title="Vila Sol Caffe Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4501.295524033993!2d-8.093702152953515!3d37.0837697660036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab56bec001ec1%3A0x33bbd30f5b8140ba!2sVila%20Sol%20Cafe!5e0!3m2!1sen!2spt!4v1751106391619!5m2!1sen!2spt"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default MapSection;
